import { Item, Select } from './style'

const SelectOptions = ({ setUnity, unity, handle, disabled, className }) => {
  return (
    <Item className={className}>
      <label>Unidade *</label>
      <Select
        name="unidade"
        value={unity}
        disabled={disabled}
        onChange={
          setUnity
            ? (e) => setUnity(e.target.value)
            : handle
            ? (e) => handle(e, e.target.value)
            : null
        }
      >
        <option value="Uni">Uni</option>
        <option value="G">G</option>
        <option value="L">L</option>
        <option value="Ml">Ml</option>
        <option value="Duzia">Duzia</option>
        <option value="Outro">Outro</option>
      </Select>
    </Item>
  )
}
export default SelectOptions
